import axiosClient from "../apiClient.js";

const baseEndpoint = "/PhotoType";

export const photoTypeObject = {
  userName: "",
  id: 0,
  photoTypeName: "",
};


export const save = (data) => {
  return axiosClient.post(`${baseEndpoint}/save`, JSON.stringify(data));
};

